import styled, { css } from 'styled-components';
import { fonts } from '../../variables/fonts.js';
import { colorAliases, colors } from '../../variables/colors.js';
import { deviceWidths } from '../../variables/widths.js';

var GuestRatingContainer = styled.div.withConfig({
  displayName: "style__GuestRatingContainer",
  componentId: "sc-hkuzi3-0"
})(["display:inline-block;line-height:1;text-align:center;", ""], function (props) {
  return props.onClick && css(["cursor:pointer;"]);
});
var GuestRatingHeader = styled.span.withConfig({
  displayName: "style__GuestRatingHeader",
  componentId: "sc-hkuzi3-1"
})(["display:block;font-family:", ";font-size:16px;padding-bottom:8px;text-transform:uppercase;"], fonts.bold);
var GuestRatingGrade = styled.span.withConfig({
  displayName: "style__GuestRatingGrade",
  componentId: "sc-hkuzi3-2"
})(["color:", ";font-family:", ";font-size:24px;", ""], colorAliases.text, fonts.regular, function (props) {
  return props.responsive && css(["@media (max-width:", "){font-size:21px;}"], deviceWidths.tabletMax);
});
var GuestRatingScale = styled.span.withConfig({
  displayName: "style__GuestRatingScale",
  componentId: "sc-hkuzi3-3"
})(["color:", ";font-size:20px;margin-top:0;", ""], colors.mediumGray, function (props) {
  return props.responsive && css(["@media (max-width:", "){font-size:15px;}"], deviceWidths.tabletMax);
});
var GuestRatingLabel = styled.span.withConfig({
  displayName: "style__GuestRatingLabel",
  componentId: "sc-hkuzi3-4"
})(["color:", ";display:block;font-size:14px;text-align:center;&::after{font-size:10px;margin-left:3px;}", ""], colors.mediumGray, function (props) {
  return props.responsive && css(["@media (max-width:", "){display:none;}"], deviceWidths.tabletMax);
});
var GuestRatingLinkContainer = styled.span.withConfig({
  displayName: "style__GuestRatingLinkContainer",
  componentId: "sc-hkuzi3-5"
})([".sg-guest-rating__link{font-size:14px;margin:0 auto;svg{height:10px;width:10px;}}", ""], function (props) {
  return props.responsive && css(["@media (max-width:", "){display:none;}"], deviceWidths.tabletMax);
});

export { GuestRatingContainer, GuestRatingGrade, GuestRatingHeader, GuestRatingLabel, GuestRatingLinkContainer, GuestRatingScale };
//# sourceMappingURL=style.js.map
